import * as React from 'react';
import styles from './ClearIcon.module.css';

export enum ClearIconColour {
  Blue,
  Grey,
}

const colours = {
  [ClearIconColour.Blue]: styles.blue,
  [ClearIconColour.Grey]: styles.grey,
};

interface Props {
  colour: ClearIconColour;
}

export function ClearIcon({ colour }: Props): React.ReactElement {
  return (
    <div className={colours[colour]}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          d="M12 13.414l-5.293 5.293-1.414-1.414L10.586 12 5.293 6.707l1.414-1.414L12 10.586l5.293-5.293 1.414 1.414L13.414 12l5.293 5.293-1.414 1.414L12 13.414z"
        />
      </svg>
    </div>
  );
}
